import { render, staticRenderFns } from "./FTPSCsRes.vue?vue&type=template&id=2f2d0b66&scoped=true&"
import script from "./FTPSCsRes.vue?vue&type=script&lang=js&"
export * from "./FTPSCsRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2d0b66",
  null
  
)

export default component.exports